import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconSurroundingsRiverComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M.7 13.27h.97c1 0 2.22-.02 3.41-.2 1.75-.28 3.03-.85 3.91-1.73a4.7 4.7 0 0 0 1.33-3.46c0-1.36.47-2.48 1.45-3.4a9.2 9.2 0 0 1 3.65-1.97 27.81 27.81 0 0 1 7.88-1 .7.7 0 1 0 0-1.42c-2.22 0-5.46.19-8.3 1.08-1.78.55-3.2 1.32-4.2 2.28A5.9 5.9 0 0 0 8.9 7.88 3.3 3.3 0 0 1 8 10.35c-1.55 1.54-4.87 1.53-6.85 1.52H.7a.7.7 0 0 0 0 1.4Z" />
        <path d="M23.3 2.77c-1.67 0-4.08.18-6.09 1.08-2.36 1.04-3.6 2.85-3.6 5.22v.27a2.69 2.69 0 0 0-1.93 3.63 3.2 3.2 0 0 0 .59 4.92c0 .27.04.6.14.92-2.04 1.87-5.97 2.82-11.7 2.82a.7.7 0 1 0 0 1.4c6 0 10.1-.99 12.46-3.01.7.65 1.66.89 2.51.95v2.24a.7.7 0 1 0 1.4 0v-2.27c1.63-.21 2.46-.99 2.9-1.65.28-.45.44-.95.48-1.37a3.2 3.2 0 0 0 .62-4.95 2.69 2.69 0 0 0-2.07-3.66 2.69 2.69 0 0 0-3.74-1.78c.4-1.04 1.23-1.83 2.52-2.4.98-.44 2.73-.96 5.5-.96a.7.7 0 0 0 0-1.4Zm-6.9 5.91c.71 0 1.28.57 1.28 1.27v.03a.7.7 0 0 0 .78.71h.14a1.28 1.28 0 0 1 1.03 2.03.7.7 0 0 0 .16 1 1.8 1.8 0 0 1-.32 3.13.7.7 0 0 0-.4.82c0 .15-.07.66-.47 1.1-.5.54-1.3.81-2.4.81-1.05 0-1.81-.25-2.2-.74a1.56 1.56 0 0 1-.32-1.11.7.7 0 0 0-.39-.88 1.8 1.8 0 0 1-.32-3.14.7.7 0 0 0 .17-1 1.28 1.28 0 0 1 1.2-2.02.7.7 0 0 0 .8-.7v-.04c0-.7.57-1.27 1.27-1.27ZM2.29 9.05h3.16a2.29 2.29 0 0 0 .08-4.57 2.28 2.28 0 0 0-3.91.1 2.28 2.28 0 0 0 .67 4.47Zm-.1-3.16a.7.7 0 0 0 .58-.47.88.88 0 0 1 1.67.02.7.7 0 0 0 .82.47.88.88 0 1 1 .19 1.74H2.3a.88.88 0 0 1-.1-1.76Z" />
      </svg>
    </SvgIcon>
  );
};

IconSurroundingsRiverComponent.displayName = 'IconSurroundingsRiver';

const IconSurroundingsRiver = React.memo(IconSurroundingsRiverComponent);

export default IconSurroundingsRiver;
